module.exports = __webpack_public_path__ + "img/movilizacion.28c85e41.jpg";